import classNames from 'classnames';
import { twMerge } from 'tailwind-merge';

export const Skeleton = ({
    className,
    ...props
}: React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
>) => {
    return (
        <div
            className={twMerge(
                classNames(
                    'w-full animate-pulse rounded-full bg-secondary-95 py-s',
                    className
                )
            )}
            aria-busy="true"
            {...props}
        />
    );
};
